import React, { ChangeEvent, useState } from 'react';
import { Form } from 'react-bootstrap';
import { AdminNavbar } from "../../Components/Navbars"
import { Button } from 'antd';
import usePortalService from '../../services/PortalService';
import { Link } from 'react-router-dom';

export const ProfileContacts = () => {
    const {getContactsByReactionId} = usePortalService();

    const [idReaction, setIdReaction] = useState('');
    const [idReactionError, setIdReactionError] = useState('');
    const [isItCandidate, setIsItCandidate] = useState(false);

    const [idProfile, setIdProfile] = useState('');
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [patronymic, setPatronymic] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');

    const idHandler = (e: ChangeEvent<HTMLInputElement>) => {
        if (Number(e.target.value) || e.target.value === '') {
            setIdReaction(e.target.value);
            setIsItCandidate(false);
            setIdReactionError('');
        }
        else {
            const value = String(e.target.value).split('/');
            if (value[3] == 'reaction') {
                setIsItCandidate(false);
                setIdReaction(value[4]);
                setIdReactionError('');
            }
            if (value[3] == 'candidate') {
                setIsItCandidate(true);
                setIdReaction(value[4]);
                clearValues();
                setIdReactionError('Вы указали ссылку на страницу кандидата, чтобы посмотреть контактные данные перейдите на неё с помощью кнопки ниже.');
            }
            else {
                setIdReactionError('Вы ввели странную ссылку');
            }
        }
    }

    const clearValues = () => {
        setIdProfile('');
        setLastName('');
        setFirstName('');
        setPatronymic('');
        setPhoneNumber('');
        setEmail('');
    }

    const sendHandler = () => {
        if (idReaction && Number(idReaction)) {
            getContactsByReactionId(idReaction).then(result => {
                if (result.success) {
                    setIdProfile(result.profileId);
                    setLastName(result.lastName);
                    setFirstName(result.firstName);
                    setPatronymic(result.patronymic);
                    setPhoneNumber(result.phoneNumber);
                    setEmail(result.email);
                }
                else {
                    setIdReactionError(result.errors);
                    clearValues();
                }
            })
        } else {
            setIdReactionError('Введите ID отклика');
            clearValues();
        }
    }

    return (
        <>
            <AdminNavbar />
            <div className="page700" style={{marginBottom:'115px'}}>
                <h1 style={{ marginBottom: '17px'}}> Получение контактных данных </h1>
                <p style={{ marginBottom: '8px' }}> Для полученую контактных данных по отклику введите id или ссылку на отклик в поле ниже. Для получения контактных данных по id студента, просто откройте его страницу. </p>
                <Form style={{ marginBottom: '17px'}}>
                    <div className="form-group">
                        <Form.Label> Ссылка или ID отклика </Form.Label>
                        <Form.Control 
                            type="text" 
                            name='idReaction'
                            value={idReaction} 
                            onChange={(e: ChangeEvent<HTMLInputElement>) => idHandler(e)}
                            isInvalid={!!idReactionError} 
                        />
                        {(idReactionError) && <p className="error-alert">{idReactionError}</p>}
                    </div>
                    {(!isItCandidate) && <Button type="primary" onClick={sendHandler}>
                        Запросить данные
                    </Button>}
                </Form>
                {(isItCandidate) && <Link to={"/candidate/"+idReaction}> Открыть страницу кандидата </Link>}
                {(idProfile) && <Link to={"/candidate/"+idProfile}> {lastName} {firstName} {patronymic} </Link>}
                {(phoneNumber) && <p> Телефон: {phoneNumber} </p> }
                {(email) && <p> Электронная почта: {email} </p>}
            </div>
        </>
    )
}